import { CommonModule, registerLocaleData } from '@angular/common';
import { Component, LOCALE_ID, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterLink, RouterLinkActive } from '@angular/router';
import {
  IonApp,
  IonSplitPane,
  IonMenu,
  IonContent,
  IonList,
  IonListHeader,
  IonNote,
  IonMenuToggle,
  IonItem,
  IonIcon,
  IonLabel,
  IonRouterOutlet,
  IonRouterLink,
  IonImg,
} from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import {
  mailOutline,
  mailSharp,
  paperPlaneOutline,
  paperPlaneSharp,
  heartOutline,
  heartSharp,
  archiveOutline,
  archiveSharp,
  trashOutline,
  trashSharp,
  warningOutline,
  warningSharp,
  bookmarkOutline,
  bookmarkSharp,
  settings,
  settingsOutline,
  settingsSharp,
  calculator,
  calculatorOutline,
  calculatorSharp,
  helpOutline,
  helpSharp,
} from 'ionicons/icons';
import { MenuController } from '@ionic/angular/standalone';
import { TenantConfigService } from './services/tenant-config.service';
import localeDe from '@angular/common/locales/de';
import { register } from 'swiper/element/bundle';
register();

// Register the locale data
registerLocaleData(localeDe, 'de');

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  imports: [
    RouterLink,
    RouterLinkActive,
    CommonModule,
    IonApp,
    IonSplitPane,
    IonMenu,
    IonContent,
    IonList,
    IonListHeader,
    IonNote,
    IonMenuToggle,
    IonItem,
    IonIcon,
    IonLabel,
    IonRouterLink,
    IonRouterOutlet,
    IonImg,
    IonRouterLink,
    IonApp,
    IonSplitPane,
    IonMenu,
    IonContent,
    IonList,
    IonImg,
    IonListHeader,
    IonMenuToggle,
    IonItem,
    IonIcon,
    IonLabel,
    IonRouterOutlet,
  ],
  providers: [{ provide: LOCALE_ID, useValue: 'de-DE' }],
})
export class AppComponent implements OnInit {
  public appPages = [
    {
      title: 'Photovoltaik',
      url: '/pv-kalkulator',
      icon: 'calculator',
      disabled: false,
    },

    {
      title: 'Einstellungen',
      url: '/settings',
      icon: 'settings',
      disabled: false,
    },
  ];

  public filteredAppPages = this.appPages.filter((p) => p.title !== 'Einstellungen');

  public settingsPage = this.appPages.find((p) => p.title === 'Einstellungen');

  public tenantConfig: any = {};

  constructor(private router: Router, private menuCtrl: MenuController, private tenantConfigService: TenantConfigService) {
    addIcons({
      mailOutline,
      mailSharp,
      paperPlaneOutline,
      paperPlaneSharp,
      heartOutline,
      heartSharp,
      archiveOutline,
      archiveSharp,
      trashOutline,
      trashSharp,
      warningOutline,
      warningSharp,
      bookmarkOutline,
      bookmarkSharp,
      settings,
      settingsOutline,
      settingsSharp,
      calculator,
      calculatorOutline,
      calculatorSharp,
      helpOutline,
      helpSharp,
    });
  }

  ngOnInit() {
    // Dynamically load tenant configuration
    this.tenantConfig = this.tenantConfigService.getConfig();

    console.log(this.tenantConfig);

    // Listen for route changes to enable/disable side menu on login
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const isLoginPage = event.urlAfterRedirects === '/login';
        this.menuCtrl.enable(!isLoginPage); // Disable menu if on login page
      }
    });
  }
}
